<template>
    <div id="app" class="app fond">
       <div>
            <h1>La page n'existe pas</h1>
            <p class="paragraphe-en-tete">Veuillez retournez à la page d'<router-link to="/">Accueil</router-link></p>
       </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'Erreur404',
    data () {
        return{
        }
    }, 

    created(){
    },

}
</script>

<style scoped>
#app{
    position: relative;
    z-index: 0;
}
.DivImageHautPageAccueil{
    width: 100vw;
    height: 80vh;
    position: fixed;
    overflow: hidden;
    border-radius: 0;
    top: 0;
    left: 0;
    z-index: -10;
}

@media(min-width: 1401px){
    .DivImageHautPageAccueil>img{
        min-width: 100%;
        max-width: 120%;
        height: auto;
        min-height: 100%;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        border-radius: 0;
    }
}

@media(max-width: 1400px){
    .DivImageHautPageAccueil>img{
        min-width: auto;
        height: 100%;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        border-radius: 0;
    }
}

.fond-page-Accueil{
    background-color: #F2F2F2;
    margin-top: 80vh;
    z-index: 1;
    width: 100vw;
}
</style>




// WEBPACK FOOTER //
// src/components/Erreur404.vue